import { render, staticRenderFns } from "./ArrearsStatistics.vue?vue&type=template&id=4207a527&scoped=true"
import script from "./ArrearsStatistics.vue?vue&type=script&lang=js"
export * from "./ArrearsStatistics.vue?vue&type=script&lang=js"
import style0 from "./ArrearsStatistics.vue?vue&type=style&index=0&id=4207a527&prod&scoped=true&lang=css"
import style1 from "./ArrearsStatistics.vue?vue&type=style&index=1&id=4207a527&prod&lang=css"
import style2 from "./ArrearsStatistics.vue?vue&type=style&index=2&id=4207a527&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4207a527",
  null
  
)

export default component.exports